module.exports = __webpack_public_path__ + "img/logo.340dd26b.svg";